import React from "react";
import style from "../../assets/css/home.module.scss";
import {Grid} from "@mui/system";
import WholesaleImg from "../../assets/img/home/Wholesale.svg";
import RetailImg from "../../assets/img/home/Retail.svg";
import PreciousMetalsImg from "../../assets/img/home/precious-metals.webp";
import ManufacturingImg from "../../assets/img/home/Manufacturing.svg";
import WatchTradeImg from "../../assets/img/home/Watch-Trade.svg";
import PawnbrokersImg from "../../assets/img/home/Pawnbrokers.svg";
import FineArtImg from "../../assets/img/home/Fine-Art-Dealers.svg";

function Expertise() {
  return (
    <>
      <section className={style.expertiseSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}}>
            <div className={style.titleMain}>
              <h2> Our areas of expertise </h2>
              <p>
                Get your valuables covered against risks from accidental damage,
                fire, burglary &amp; theft.
              </p>
            </div>

            <div className={style.expertiBoxMain}>
              <div className={style.expertiBox}>
                <img alt="wholesale" src={WholesaleImg} />
                <p> Wholesale </p>
              </div>
              <div className={style.expertiBox}>
                <img alt="Retail" src={RetailImg} />
                <p> Retail </p>
              </div>
              <div className={style.expertiBox}>
                <img alt="Precious" src={PreciousMetalsImg} />
                <p> Precious Metals </p>
              </div>
              <div className={style.expertiBox}>
                <img alt="Manufacturing" src={ManufacturingImg} />
                <p> Manufacturing </p>
              </div>
              <div className={style.expertiBox}>
                <img alt="Watch" src={WatchTradeImg} />
                <p> Watch Trade </p>
              </div>
              <div className={style.expertiBox}>
                <img alt="Pawnbrokers" src={PawnbrokersImg} />
                <p> Pawnbrokers </p>
              </div>
              <div className={style.expertiBox}>
                <img alt="Fine" src={FineArtImg} />
                <p> Fine Art Dealers </p>
              </div>
            </div>
          </Grid>
        </Grid>
      </section>
    </>
  );
}

export default Expertise;
